'use client';

import { ColumnDef } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import type { ProjectAnalysisReportAdmin } from '@/graphql/types/projectAnalysis';
import { dateFormat } from '@/utils/functions/dateFormat';

export type ProjectAnalysisAdminRow = ProjectAnalysisReportAdmin & { actions: ReactNode };

export const projectAnalysisAdminColumns: ColumnDef<ProjectAnalysisAdminRow>[] = [
  {
    accessorKey: 'title',
    header: 'Título',
    size: 220,
    cell: function TitleCell({ row }: { row: { original: ProjectAnalysisAdminRow } }) {
      return (
        <div className="whitespace-normal break-words max-w-[200px]">{row.original.title}</div>
      );
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
    size: 120,
    cell: function StatusCell({ row }: { row: { original: ProjectAnalysisAdminRow } }) {
      const s = row.original.status;
      const cls =
        s === 'PUBLISHED' ? 'bg-green-600' : s === 'ARCHIVED' ? 'bg-slate-500' : 'bg-amber-600';
      return <div className={`w-fit px-2 py-1 rounded-md text-white text-xs ${cls}`}>{s}</div>;
    },
  },
  {
    accessorKey: 'recipient_count',
    header: 'Destinatários',
    size: 120,
    cell: function RecipientsCell({ row }: { row: { original: ProjectAnalysisAdminRow } }) {
      return <span>{row.original.recipient_count}</span>;
    },
  },
  {
    accessorKey: 'published_at',
    header: 'Publicado em',
    size: 180,
    cell: function PublishedCell({ row }: { row: { original: ProjectAnalysisAdminRow } }) {
      const v = row.original.published_at;
      return <span>{v ? dateFormat(new Date(v)) : '—'}</span>;
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Criado em',
    size: 180,
    cell: function CreatedCell({ row }: { row: { original: ProjectAnalysisAdminRow } }) {
      return <span>{dateFormat(new Date(row.original.created_at))}</span>;
    },
  },
  {
    id: 'actions',
    header: 'Ações',
    size: 80,
    cell: function ActionsCell({ row }: { row: { original: ProjectAnalysisAdminRow } }) {
      return row.original.actions;
    },
  },
];
